var map = {
	"./site-logo-desktop-footer.svg": 94915,
	"./site-logo-desktop.svg": 58293,
	"./site-logo-drawer-mobile.svg": 23383,
	"./site-logo-drawer.svg": 56772,
	"./site-logo-external.svg": 81674,
	"./site-logo-mobile-drawer.svg": 7217,
	"./site-logo-mobile.svg": 89649,
	"./site-logo-sm.svg": 8475,
	"./site-logo-tv.svg": 35705,
	"./site-logo-wrapper-mobile-scrolled.svg": 372,
	"./site-logo-wrapper-mobile.svg": 6395,
	"./site-logo-wrapper-scrolled.svg": 4797,
	"./site-logo-wrapper.svg": 77368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72906;